import React, { Component } from "react";
import { Container, Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { connect } from "react-redux";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import TableScrollbar from "react-table-scrollbar";

// import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import PurchaseOrderCard from "./PurchaseOrderCard";
import QuotationCard from "./QuotationCard";
import RequestForQuotationCard from "./RFQCard";
import IndentRequestCard from "./IndentRequestCard";
import MaterialRequestCard from "./MaterialRequestCard";
import IGPCardList from "./IGPListCard";
import IGPCardView from "./IGPCardView";
import CompareQuotationCard from "./CompareQuotationCard";
import "./AuditReports.scss";
import { Link } from "react-router-dom";

import {
  // SetParams,

  OpenScreen,
} from "../../store/Audit_Report/actions";
import LoadingModel from "../LoadingModel";

class AuditReportCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // if (this.props.openScreen.ScreenNo === 1) {
    //   // this.props.getAuditPORowData(this.props.openScreen.ScreenID);
    // }
  }
  setCard(list) {
    var arr = list.map((obj, i) => {
      if (obj.screen === "PO") {
        return <PurchaseOrderCard obj={obj} index={i} />;
      } else if (obj.screen === "IGPList") {
        return <IGPCardList obj={obj} index={i} />;
      } else if (obj.screen === "IGPView") {
        return <IGPCardView obj={obj} index={i} />;
      } else if (obj.screen === "Q") {
        return <QuotationCard obj={obj} index={i} />;
      } else if (obj.screen === "RFQ") {
        return <RequestForQuotationCard obj={obj} index={i} />;
      } else if (obj.screen === "PI") {
        return <IndentRequestCard obj={obj} index={i} />;
      } else if (obj.screen === "MR") {
        return <MaterialRequestCard obj={obj} index={i} />;
      } else if (obj.screen === "CQ") {
        return <CompareQuotationCard obj={obj} index={i} />;
      }
      return null;
    });
    return arr;
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <Link
                      to="/AuditReport"
                      // onClick={() => {
                      //   this.props.history.goBack();
                      // }}
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Audit Report Card
                    </h5>
                  </CardHeader>
                  <CardBody>
                    <div className="CardBody ">
                      {this.props.AuditData.length !== 0 ? (
                        <>{this.setCard(this.props.AuditData)}</>
                      ) : (
                        <div className="text-center">
                          <span className="font-size-18 text-danger">
                            Select Purchase Order
                          </span>
                        </div>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    AuditData,
    //--------------
    loading,
    params,
    openScreen,
  } = state.AuditReport;
  return {
    AuditData,
    loading,
    params,
    openScreen,
  };
};

export default connect(mapStatetoProps, { OpenScreen })(AuditReportCard);
